
import './utils/messages';
import { NSServerCalls } from './utils/servercalls.js';
import './utils/functions.js';
import './utils/tables';
import './utils/combos';
import './utils/urn.js';
import './utils/data_types';
import { NSGeoJson } from './utils/geojson';
import { NSDateDatetime } from './utils/date_datetime'
import { NSMessages } from './utils/messages'
import { NSConfirm } from './utils/confirm'
import { NSControlsState } from './utils/controls_state'

import { NSPageLabels } from './page_labels'
import { NSDataModelInfo } from './data_model_info';
import { NSUserFunctionPermissions } from './user_function_permissions'
import { UI } from './ui';
import { NSPageSidepanel } from './page_sidepanel'
import { NSPageBottompanel } from './page_bottompanel'
import { NSObjDetails } from './obj_details'
import { NSObjDetailsGeo } from './obj_details_geo'
import { NSObjDetailsEdit } from './obj_details_edit'
import { NSObjDetailsCreate } from './obj_details_create'
import { NSObjJoinList } from './obj_join_list'
import { NSResultsInterface } from './results_interface'
import { NSToolDraw } from './tool_draw'
import { NSAdvancedSearchQueryInterface } from './advanced_search_query_interface'
import { NSGroups } from './groups'
import { NSSearchbar } from './searchbar'
import { NSPDM } from './pdm'
import { NSExport } from './export'
import { NSPrint } from './print'
import { NSMapInterface } from './map_interface'
import { NSCRS } from './utils/crs'
import { NSMiniClientMain } from './mini_client_main'
import { NSStartupAction } from './startup_action'
import { NSSearchCoordinatesToolbar } from './search_coordinates_toolbar'
import { NSHelp } from './help.js'




import {Map} from './map';
import {Overlays} from './overlays';
import { LayersTree } from './layers_tree.js'

import { NSObjectMultipleSelect } from './obj_multiple_select';
import { NSFeaturesSelect } from './map_features_select';

import 'bootstrap';
import { NSObjDetailsCloneData } from './obj_details_clone_data';
import { NSGeometryClipboard } from './geometry_clipboard.js'
import { NSStreetView } from './street_view.js'

export var xCore = {};


//console.log('core.js - 01')

function init_modules (resolve_cb)
{
  let f_on_complete = function()
  {
    resolve_cb();
  }

  NSMessages.init( {s_close_button_image_src: xCore.application.close_button_image_src} );
 
  let o_promise = NSUserFunctionPermissions.init();
  let o_promise2 = NSPageLabels.init();
  let a_promise = [o_promise, o_promise2];

  Promise.all(a_promise).then((values) => {
    NSGeoJson.init();
    NSDateDatetime.init();
    NSConfirm.init();
    NSControlsState.init();
    NSDataModelInfo.init();
    Map.init();
    NSMapInterface.init();
    NSPageSidepanel.init();
    NSPageBottompanel.init();
    NSGeometryClipboard.init();
    NSObjDetailsGeo.init();
    NSObjDetails.init();
    NSObjDetailsEdit.init();
    NSObjDetailsCreate.init();
    NSObjJoinList.init();
    NSObjDetailsCloneData.init();
    NSResultsInterface.init();
    NSToolDraw.init();
    NSGroups.init();
    NSSearchCoordinatesToolbar.init();
    NSAdvancedSearchQueryInterface.init();
    NSObjectMultipleSelect.init();
    NSFeaturesSelect.init();
    NSSearchbar.init();
    NSPDM.init();
    NSExport.init();
    NSCRS.init();
    Overlays.init();
    NSStreetView.init();
    UI.init();
    try{ NSHelp.init(); } catch(err) { console.log(err) };

    let o_promise_print = NSPrint.init();
    let o_promise_lt = LayersTree.init();
    
    let a_promise_part_02 = [o_promise_print, o_promise_lt];
    
    Promise.all(a_promise_part_02).then((values_part_02) => {
      
      NSMiniClientMain.init();
      NSStartupAction.init();
      
      f_on_complete();
    });
  });
}

//Config load
var load = (function() {
    // Function which returns a function: https://davidwalsh.name/javascript-functions
    function _load(tag) {
      return function(url) {
        // This promise will be used by Promise.all to determine success or failure
        return new Promise(function(resolve, reject) {
          var element = document.createElement(tag);
          var parent = 'body';
          var attr = 'src';
  
          // Important success and error for the promise
          element.onload = function( response ) {
            resolve(url);
          };
          element.onerror = function() {
            reject(url);
          };
  
          // Need to set different attributes depending on tag type
          switch(tag) {
            case 'script':
              element.async = true;
              element.type = 'text/javascript'
              break;
            case 'link':
              element.type = 'text/css';
              element.rel = 'stylesheet';
              attr = 'href';
              parent = 'head';
              break;
          }
  
          // Inject into document to kick off loading
          element[attr] = url;
          document[parent].appendChild(element);
        });
      };
    }
  
    return {
      css: _load('link'),
      js: _load('script'),
      img: _load('img')
    }
  })();

  
//console.log('core.js - 02')


let init_page_mode_property = function()
{

  let sPageURL = window.location.search.substring(1);
  let sURLVariables = sPageURL.split('&');
  
  let b_page_in_mini_client_mode = false;
  for (let i = 0; i < sURLVariables.length; i++) {
    let a_parameter_i = sURLVariables[i].split('=');
    let s_parameter_i_name = a_parameter_i[0];
    

    if( s_parameter_i_name == "mini" )
    {
      let s_parameter_i_value = a_parameter_i[1];
      b_page_in_mini_client_mode = ("true" === s_parameter_i_value.toLocaleLowerCase() )? true : false;
      break;
    }
  }

  xCore.application.b_page_in_mini_client_mode = b_page_in_mini_client_mode;
};

let init_page_context_property = function()
{

  let s_host = window.location.host;
  s_host = s_host.split(":")[0]; //removing port

  let a_ext = xCore.application.hosts.ext;

  let i_pos = a_ext.findIndex( (o_i) => o_i == s_host );

  let b_page_in_ext_context = (i_pos>-1)? true : false;

  xCore.application.b_page_in_ext_context = b_page_in_ext_context;
  
};

let f_init_core = function(resolve_cb)
{

  let url_mini_client_config = 'config_mini_client.json';


  let url = 'config.json';

  NSServerCalls.f_make_ajax_call_by_fetch({"url": url}).then(function(response)
  {
      let o_promise_resp_read = response.json();
      return o_promise_resp_read;      
  }).then( function(o_resp_json)
  {
      
    //console.log('core.js - 04');
    xCore = o_resp_json;
    window.xCore_ = xCore;

    init_page_mode_property();
    init_page_context_property();
    //console.log('core.js - 05');


  }).then( () => 
  {
    return NSServerCalls.f_make_ajax_call_by_fetch({"url": url_mini_client_config});

  }).then(function(response)
  {
    return response.json(); 
  }).then( (o_mini_client_config_json) =>
  {
    xCore.mini_client_cfg = o_mini_client_config_json;
  }).then ( function()
  {
    
    let moduleLoader = []; // [f_anonymous(f_resolve(s_url), f_reject(s_url)]

    for(var key in xCore.loader.modules)
      moduleLoader.push(load.js(xCore.loader.modules[key].source));
    for(var key in xCore.loader.styles)
      moduleLoader.push(load.css(xCore.loader.styles[key].source));
    for(var key in xCore.loader.images)
      moduleLoader.push(load.img(xCore.loader.images[key].source));

    //console.log('core.js - 06');
    Promise.all(moduleLoader)
    .then((values) => {
      //console.log('core.js - 08.A');
      //console.log(values);
      init_modules(resolve_cb);
    })
    .catch(error => {
      //console.log('core.js - 08.B');
      console.log(error);
      console.error(error.message)
      console.log('error on core.js while loading modules');
    });

    //console.log('core.js - 07');
  })
  .catch(err => { 
      console.log(err);
      console.log( "error" + err.status + err.statusText );
  });

}

export let o_promise_core_ready = new Promise((resolve, reject) => 
  {
    f_init_core(resolve);
  }
);


export let xCoreHelper = {

  f_page_is_in_mini_client_mode: function()
  {
    return xCore.application.b_page_in_mini_client_mode;
  },
  
  f_page_is_in_ext_context: function()
  {
    return xCore.application.b_page_in_ext_context;
  },

  f_use_icon_auto_vetical_displacement: function()
  {
    /*
      If true, for vector layers, will automatically 
      verticaly displace icons so the bottom tip points to the geometric point.
    */
    let b_use_icon_vertical_displacement = false; 
    return b_use_icon_vertical_displacement;
  }

};



//console.log('core.js - 03')





